import { DefaultOption } from '@ubnt/ui-components/Dropdown/OptionComponents/DefaultOption';
import { isDropdownOption } from '@ubnt/ui-components/Dropdown/types';
import Tooltip from '@ubnt/link-core-ui/components/Tooltip';

import { memo } from 'react';

const TooltipOptionImpl = (props: React.ComponentProps<typeof DefaultOption>) => {
  const { option } = props;

  if (isDropdownOption(option) && option.tooltipDescription) {
    return (
      <Tooltip description={option.tooltipDescription}>
        <DefaultOption {...props} />
      </Tooltip>
    );
  }

  return <DefaultOption {...props} />;
};

const TooltipOption = memo(TooltipOptionImpl);

export default TooltipOption;
